 // custom js for swiper slider in zoom start //
  var mySwiper = new Swiper('.swiper-product-modal-slider', {
     slidesPerView: 1,
     spaceBetween: 0,
     loop: false,
     direction:"horizontal",
     navigation: {
       nextEl:".swiper-button-next",
       prevEl:".swiper-button-prev"
     },
     pagination: {
        el: ".swiper-pagination",
        clickable:true,
      },
     keyboard: {
       enabled:true,
       onlyInViewport:true
     },
     effect:"slide",
     speed:500,
     breakpoints: { 
       275: { slidesPerView: 1, spaceBetween: 0 },
       575: { slidesPerView: 1, spaceBetween: 0 },
       576: { slidesPerView: 1, spaceBetween: 0 },
       1199: { slidesPerView: 1,  spaceBetween: 0 },
       1200: { slidesPerView: 1,  spaceBetween: 0 }
     } 
  });


  const zoomButton = document.querySelectorAll(".product__media-toggle");
    zoomButton.forEach((button) => {
      button.addEventListener("click", () => {

        const slideImg = document.querySelectorAll(".swiper-slide");
        slideImg.forEach((slide) => {

        const btnImg = button.getAttribute("data-media-id");
        const slideImg = slide.getAttribute("data-media-id");
        const slideImgIndex = slide.getAttribute("data-slider-index");

        if(btnImg === slideImg){
          mySwiper.slideTo(slideImgIndex - 1);
          mySwiper.update();
        } else {
        }

        });
          
    });
  });
 // custom js for swiper slider in zoom end //

// custom swatches for listing page start
class CustomSwatch extends HTMLElement {
  constructor() {
    super();
    var selector = '.custom-variant-swatch';
    var elements = document.querySelectorAll(selector);

    function handleClick() {
      var selectedElement = this;
      
      elements.forEach(function(element) {
        element.classList.remove('active-swatch');
      }); 
      selectedElement.classList.add('active-swatch'); 
      
      var ParentID = selectedElement.getAttribute("product-id");
      var SwatchPrice = selectedElement.getAttribute("data-price");
      var SwatchValue = selectedElement.getAttribute("data-value");
      var SwatchID = selectedElement.getAttribute("data-variantid");
      var matchedImage = selectedElement.getAttribute("data-swatch-image");
        
      const RadioValue = document.querySelectorAll("input[type='radio'].custom-variant-swatch:checked")[0].getAttribute("data-variantid");    
      
      var OneParent = selectedElement.closest(".product-card-wrapper");
      OneParent.querySelectorAll("img").forEach(function(img) {
        img.removeAttribute("srcset");
        img.setAttribute("src", matchedImage);        
      });

      var FormInputID = selectedElement.parentElement.parentElement.parentElement.parentElement.parentElement.nextElementSibling.firstElementChild.firstElementChild.nextSibling.nextSibling;
      FormInputID.setAttribute("value", SwatchID);
      FormInputID.setAttribute("data-add-id", SwatchID);

      var ImageLinkTag = selectedElement.closest(".product-card-wrapper");
      ImageLinkTag.querySelectorAll("a.full-unstyled-link").forEach(function(ProdLink) {
         var NewProdLink = ProdLink + "?"; 
         var link = NewProdLink.split('?')[0];
         NewProdLink = link + "?variant=" + SwatchID; 
         ProdLink.setAttribute("href", NewProdLink);
      });
     
    }    
    elements.forEach(function(element) {
      element.addEventListener("click", handleClick);
    });
  }
}
customElements.define("custom-color-swatch", CustomSwatch);   
// custom swatches for listing page end
